import script from "./WebsiteAiView.vue?vue&type=script&setup=true&lang=js"
export * from "./WebsiteAiView.vue?vue&type=script&setup=true&lang=js"

import "./WebsiteAiView.vue?vue&type=style&index=0&id=8a68291c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a68291c"]])

export default __exports__